 <template>
	<div class="window">
        <div class="header"><span v-html="translation.poziomy"></span>
            <a class="description" @click="openDescription"><information-circle-icon class="icon"/></a>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <div class="below-header">
                <div class="category-list" v-for="(level, index) in levels" :key="level.ID" @click="showDetails(index+1)">
                    <div v-bind:id="level.ID">
                        <div class="category-name">{{ translation[level.name] }}</div>
                        <div class="category-levels">
                            <div class="empty" v-for="el in level.sublevels" :key="el.sublevel">
                                <div class="level-icon" :class="el.status==2?'finished':el.status==1?'rainbow progress':''" >
                                    <check-circle-icon class="icon" v-if="el.status==2"></check-circle-icon>
                                    <star-icon class="icon" v-else-if="el.status==0"></star-icon>
                                    <sparkles-icon class="icon rainbow" v-else-if="el.status==1"></sparkles-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <button class="btn btn-all btn-green" v-html="translation[phrase]" @click="startGry" v-if="!is_finished"></button>
            <button class="btn btn-all btn-green" v-html="translation.podsumowanie_wynikow" @click="raportGry" v-else-if="is_finished"></button>
        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon, InformationCircleIcon } from '@heroicons/vue/24/solid';
import { CheckCircleIcon, SparklesIcon, StarIcon } from '@heroicons/vue/24/outline';

export default {
    name: 'PlanszaPoziomow',
    props: {
        language: String,
        category: Number,
        subcategory: Number,
        offset: Number,
    },
    components: { 
        Cog6ToothIcon,
        InformationCircleIcon,
        SparklesIcon,
        StarIcon,
        CheckCircleIcon
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
            levels: '',
            is_finished: false,
            localCategory: 0,
            localSubCategory: 0,
            localOffset: 0,

            phrase: 'rozpocznij_gre'
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }

        let arr = new Array();
        let newone;
        for(let level_idx = 1; level_idx <= 6; level_idx++) {
            let sublevels = new Array();
            for(let sublevel_idx = 1; sublevel_idx <=3; sublevel_idx++) {
                sublevels.push(JSON.parse(localStorage.getItem('levels-'+level_idx+'-'+sublevel_idx)));
            }
            newone = JSON.parse(localStorage.getItem('levels-'+level_idx+'-1'));
            newone.sublevels=sublevels;
            arr.push(newone);
        }
        this.levels = arr;
        this.choosePhrase();

        let last_level = JSON.parse(localStorage.getItem('levels-6-3'));
        last_level = last_level.status;
        console.log('LL: '+last_level)
        if (last_level == 2) {
            this.is_finished = true;
        }
    },
    methods: {
        raportGry() {
            this.$emit('show-summary-report');
        },
        choosePhrase() {
            let klucz = localStorage.getItem('klucz');
            /*
            pobieram dane z klucza
            */
            if (klucz == null || klucz == '' || klucz.length!=3) {
                this.localCategory = 0;
                this.localSubCategory = 0;
            } else {
                klucz = klucz.split('-');
                this.localCategory = klucz[0]
                this.localSubCategory = klucz[1]
            }
            let offset = localStorage.getItem('game-offset');
            if (offset == null || offset == '') {
                this.localOffset = 0;
            } else {
                this.localOffset = offset;
            }

            if (this.localCategory == 6 && this.localSubCategory == 3 && this.offlocalOffsetset == 20)
                this.phrase = 'podsumowanie_wynikow'
            else if (this.localCategory>0 && this.localOffset==20)
                this.phrase = 'graj_dalej';
            else if (this.localOffset>0 && this.localOffset<20)
                this.phrase = 'dokoncz_gre';
            else
                this.phrase = 'rozpocznij_gre';
        },
        startGry() {
            this.$emit('go-start-gry');
        },
        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
        showDetails(category) {
            this.$emit('show-category-details', category);
        },
        tempPodsumowanie() {
            this.$emit('oplacenie');
        }
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        },
        localOffset() {
            this.choosePhrase()
        },
        localCategory() {
            this.choosePhrase()
        },
        localSubCategory() {
            this.choosePhrase()
        },

    },
}
</script>

<style scoped>
.rainbow {
    animation: rainbow_animation 1s linear infinite;
}

@keyframes rainbow_animation {
    0% {
        color:  #ff0;
    }
    50% {
        color: #f32878;
    }
    100% {
        color:  #ff0;
    }    
}

.finished {
    color: var(--bs-gradient-to);
}
.progress {
    color: var(--bs-second-bg);
}
.category-list {
    border: 1px solid #bbb;
    background-color: var(--bs-box-background);
    border-radius: 10px;
    padding: 16px 10px;
    font-size: 1em;
    margin: 1em 0;
    position: relative;
}
.category-list .category-name {
    font-weight: 500;
    font-size: 1em;
    text-align:left;
}
.category-list .category-levels {
    display: block;
    position: absolute;
    right: 7px;
    top: 14px;
}
.category-list .category-levels div.empty {
    color: #999;
    display: inline-block;
}

.level-icon {
    width:25px;
    display: inline-block;
}
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}

.bottom {
    position:fixed;
    bottom:10px;
    left:0;
    right:0;
    height: 60px;
    background-color:var(--bs-button-background);
}

.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 90%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}

.podpowiedz {
    background-color: #e0e0e0;
    padding: 15px;
    border: 1px solid #999;
    border-radius: 15px;
    margin-bottom: 2em;
    font-size: 1.2em;
    text-align: center;
        margin-left: 30px;
    margin-right: 30px;
}
.dark .podpowiedz {
    background-color: #333;
    /* padding: 15px; */
    border: 1px solid #999;
    /* border-radius: 15px; */
    /* margin-bottom: 2em; */
    /* font-size: 1.2em; */
    /* text-align: center; */
    color: white;
}
.mt2x {
    margin-top: 2em;
}


body.dark div.grey-box {
    /* margin: 1em 0.5em; */
    background-color: #444;
    /* padding: 1em; */
    /* border-radius: 10px; */
}

div.grey-box {
    margin: 1em 0.5em;
    background-color: #eaeaea;
    padding: 1em;
    border-radius: 10px;
    overflow: auto;
}

.input-group {
    display: block;
    margin-bottom: 1em;
}
.input-group label {
    display: block;
}
body.dark .input-group input[type='text'] {
    border-top: 0 none;
    border-left: 0 none;
    border-right: 0 none;
    border-bottom: 1px solid #4e4b66;
    background-color: rgb(59, 59, 59);
    /* padding: 10px; */
    /* font-size: 20px; */
    color: white;
    /* width: calc(100% - 25px); */
    /* display: block; */
}

.input-group input[type='text'] {
    border-top: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-bottom: 1px solid #4e4b66;
    padding: 10px;
    background-color: white;
    font-size: 20px;
    color: black;
    width: calc(100% - 25px);
    display: block;
}

#komunikat {
    text-align: center;
    color: red;
    font-weight: 500;
}

</style>
